<template>
  <div class="components-input-demo-presuffix">
    <a-input
      @click="openModal"
      :placeholder="$t('disp.ph.input', [$t('disp.cronExpression')])"
      v-model="cron"
      @change="handleChange"
      allowClear
    >
      <!-- <a-icon slot="prefix" type="schedule" /> -->
      <!-- <a-icon v-if="cron" slot="suffix" type="close-circle" @click="handleEmpty" title="清空" /> -->
    </a-input>
    <component v-if="!!src" v-bind:is="src" :data="cron" ref="innerVueCron" @ok="handleOK"></component>
  </div>
</template>
<script>
export default {
  name: 'JCron',
  components: {},
  props: {
    value: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      cron: this.value,
      src: ''
    }
  },
  watch: {
    value(val) {
      this.cron = val
    }
  },
  methods: {
    openModal() {
      this.src = require('./JCronModal' + '(' + JSON.parse(localStorage['pro__Locale']).value + ')').default
      // this.$refs.innerVueCron.show()

      var that = this
      var interval = setInterval(() => {
        if (that.$refs.innerVueCron && that.$refs.innerVueCron.visible != undefined) {
          that.$refs.innerVueCron.visible = true
          window.clearInterval(interval)
        }
      }, 100)
    },
    handleOK(val) {
      this.cron = val
      this.$emit('change', this.cron)
      this.$emit('input', this.cron)
      //this.$emit("change", Object.assign({},  this.cron));
    },
    handleChange(e) {
      this.$emit('change', this.cron)
      this.$emit('input', this.cron)
      //this.$emit("change", Object.assign({},  this.cron));
    },
    handleEmpty() {
      this.handleOK('')
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>
<style lang="less" scoped>
/* .components-input-demo-presuffix .anticon-close-circle {
    cursor: pointer;
    color: #ccc;
    transition: color 0.3s;
    font-size: 12px;
  }
  .components-input-demo-presuffix .anticon-close-circle:hover {
    color: #f5222d;
  }
  .components-input-demo-presuffix .anticon-close-circle:active {
    color: #666;
  } */

/deep/ .ant-input {
  cursor: pointer;
}
</style>
